"use strict";

exports.__esModule = true;
exports.EditableDeviceTableHeaderCell = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _core = require("@blueprintjs/core");
var _reactDnd = require("react-dnd");
var _ElementEditorContextMenu = require("../../ConfigurableLayout/ElementEditor/ElementEditorContextMenu");
var _dec, _dec2, _class, _EditableDeviceTableHeaderCell;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var elementSource = {
  beginDrag: function beginDrag(props) {
    var element = props.element,
      path = props.path,
      elementEditor = props.elementEditor;
    elementEditor.beginDrag(path);
    return {
      element: element,
      path: path
    };
  },
  endDrag: function endDrag(props) {
    var elementEditor = props.elementEditor;
    elementEditor.endDrag();
  }
};
var widgetTarget = {
  drop: function drop(props, monitor) {
    var elementEditor = props.elementEditor;
    var hasDroppedOnChild = monitor.didDrop();
    if (hasDroppedOnChild || !monitor.isOver({
      shallow: true
    })) {
      return;
    }
    var itemType = monitor.getItemType();
    if (itemType === "element") {
      var _monitor$getItem = monitor.getItem(),
        path = _monitor$getItem.path;
      elementEditor.moveElementAt(path, props.path);
    } else if (itemType === "widget") {
      var _monitor$getItem2 = monitor.getItem(),
        widget = _monitor$getItem2.widget;
      var element = widget.createElement();
      elementEditor.appendElementAt(props.path, element);
    }
  }
};

/**
 * Displays an editable grid.
 */
var EditableDeviceTableHeaderCell = exports.EditableDeviceTableHeaderCell = (_dec = (0, _reactDnd.DropTarget)(["widget", "element"], widgetTarget, function (connect) {
  return {
    connectDropTarget: connect.dropTarget()
  };
}), _dec2 = (0, _reactDnd.DragSource)("element", elementSource, function (connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
}), (0, _reactIntl.injectIntl)(_class = _dec(_class = _dec2(_class = (_EditableDeviceTableHeaderCell = /*#__PURE__*/function (_React$PureComponent) {
  function EditableDeviceTableHeaderCell() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.handleClick = function (e) {
      e.preventDefault();
      e.stopPropagation();
      var _this$props = _this.props,
        path = _this$props.path,
        elementEditor = _this$props.elementEditor;
      elementEditor.selectElementAt(path);
    };
    _this.handleContextMenu = function (e) {
      e.preventDefault();
      e.stopPropagation();
      var _this$props2 = _this.props,
        path = _this$props2.path,
        elementEditor = _this$props2.elementEditor,
        intl = _this$props2.intl;
      var menu = /*#__PURE__*/_react["default"].createElement(_ElementEditorContextMenu.ElementEditorContextMenu, {
        path: path,
        elementEditor: elementEditor,
        intl: intl
      });
      (0, _core.showContextMenu)({
        content: menu,
        targetOffset: {
          left: e.clientX,
          top: e.clientY
        }
      });
    };
    return _this;
  }
  _inheritsLoose(EditableDeviceTableHeaderCell, _React$PureComponent);
  var _proto = EditableDeviceTableHeaderCell.prototype;
  _proto.render = function render() {
    var _this$props3 = this.props,
      width = _this$props3.width,
      height = _this$props3.height,
      isDragging = _this$props3.isDragging,
      connectDragSource = _this$props3.connectDragSource,
      connectDropTarget = _this$props3.connectDropTarget,
      elementEditor = _this$props3.elementEditor,
      path = _this$props3.path,
      children = _this$props3.children;
    var isSelected = elementEditor.isElementSelectedAt(path);
    var style = {
      width: width,
      height: height,
      display: "flex",
      borderRight: "solid 1px rgba(0, 0, 0, 0.1)",
      justifyContent: "center",
      alignItems: "center",
      zIndex: isSelected ? 99 : undefined,
      background: isSelected ? "rgba(175, 226, 241, 0.3)" : undefined,
      outlineLeft: "dashed " + (isSelected ? "#26bbe4" : "rgba(0, 0, 0, 0.1)") + " 1px",
      outlineRight: "dashed " + (isSelected ? "#26bbe4" : "rgba(0, 0, 0, 0.1)") + " 1px"
    };
    if (isDragging) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style
      });
    }
    return connectDropTarget(connectDragSource(/*#__PURE__*/_react["default"].createElement("div", {
      style: style,
      onClickCapture: this.handleClick,
      onContextMenuCapture: this.handleContextMenu
    }, children)));
  };
  return EditableDeviceTableHeaderCell;
}(_react["default"].PureComponent), _EditableDeviceTableHeaderCell.defaultProps = {
  intl: undefined,
  isDragging: undefined,
  connectDropTarget: undefined,
  connectDragSource: undefined
}, _EditableDeviceTableHeaderCell)) || _class) || _class) || _class);